import { HttpClient, HttpParams } from '@angular/common/http';
import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { FlyGarminLegacyBaseUrl, FlyAdminLegacyBaseUrl } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
const AVDB_SUBSCRIPTIONS_SERVICE_TOKEN = new InjectionToken('AVDB_SUBSCRIPTIONS_SERVICE_TOKEN');
class AbstractAvdbSubscriptionsService {
  constructor() {
    this.http = inject(HttpClient);
  }
  getAvdbSubscriptions(billingAccountId, masterAircraftUuid, deviceId, includeExpired = false, includePrice = false, includeFuture = false) {
    if (![billingAccountId, masterAircraftUuid, deviceId].some(id => id != null)) {
      return throwError(() => new Error('Neither billingAccountId, masterAircraftUuid, nor deviceId were provided'));
    }
    let params = new HttpParams().set('includeExpired', includeExpired).set('includePrice', includePrice).set('includeFuture', includeFuture);
    if (billingAccountId != null) {
      params = params.set('billingAccountId', billingAccountId);
    }
    if (masterAircraftUuid != null) {
      params = params.set('masterAircraftUuid', masterAircraftUuid);
    }
    if (deviceId != null) {
      params = params.set('deviceId', deviceId);
    }
    return this.http.get(this.baseUrl, {
      params
    });
  }
}
const PROMO_CODE_SERVICE_TOKEN = new InjectionToken('PROMO_CODE_SERVICE_TOKEN');
/**
 * @deprecated This service is deprecated and will be removed.
 * Use GarminPilotSubscriptionsService instead.
 */
class AbstractPromoCodeService {
  constructor() {
    this.http = inject(HttpClient);
  }
  getPromoCode(promoCode) {
    return this.http.get(`${this.url}${promoCode}`);
  }
  redeemPromoCode(promoCodeRedeemPayload) {
    return this.http.post(`${this.url}redeem`, promoCodeRedeemPayload);
  }
}
const GARMIN_PILOT_DEVICE_REGISTRATIONS_CONTROLLER_CLIENT_TOKEN = new InjectionToken('GARMIN_PILOT_DEVICE_REGISTRATIONS_CONTROLLER_CLIENT_TOKEN');
const GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN = new InjectionToken('GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN');
const SKU_SERVICE_TOKEN = new InjectionToken('SKU_SERVICE_TOKEN');
const SUBSCRIPTIONS_CONTROLLER_CLIENT_TOKEN = new InjectionToken('SUBSCRIPTIONS_CONTROLLER_CLIENT_TOKEN');
const MOBILE_DEVICE_SERVICE_TOKEN = new InjectionToken('MOBILE_DEVICE_SERVICE_TOKEN');
const REVOKE_SUBSCRIPTION_SERVICE_TOKEN = new InjectionToken('REVOKE_SUBSCRIPTION_SERVICE_TOKEN');
const SUBSCRIPTIONS_JOB_MANAGEMENT_TOKEN = new InjectionToken('SUBSCRIPTIONS_SERVICE_TOKEN');
const SUBSCRIPTIONS_SERVICE_TOKEN = new InjectionToken('SUBSCRIPTIONS_SERVICE_TOKEN');
var AvdbDeviceIdType = /*#__PURE__*/function (AvdbDeviceIdType) {
  AvdbDeviceIdType[AvdbDeviceIdType["SYSTEM_ID"] = 1] = "SYSTEM_ID";
  AvdbDeviceIdType[AvdbDeviceIdType["PORTABLE_DEVICE_SERIAL_NUMBER"] = 2] = "PORTABLE_DEVICE_SERIAL_NUMBER";
  AvdbDeviceIdType[AvdbDeviceIdType["AIRCRAFT_DEVICE_SERIAL_NUMBER"] = 3] = "AIRCRAFT_DEVICE_SERIAL_NUMBER";
  return AvdbDeviceIdType;
}(AvdbDeviceIdType || {});
var AvdbPricingBundleType = /*#__PURE__*/function (AvdbPricingBundleType) {
  AvdbPricingBundleType["ONEPAK"] = "onepak";
  AvdbPricingBundleType["PILOTPAK"] = "pilotpak";
  AvdbPricingBundleType["DEVICE"] = "device";
  return AvdbPricingBundleType;
}(AvdbPricingBundleType || {});
const avdbPricingBundleFilterName = {
  [AvdbPricingBundleType.ONEPAK]: 'OnePak',
  [AvdbPricingBundleType.PILOTPAK]: 'PilotPak',
  [AvdbPricingBundleType.DEVICE]: 'Device'
};
var CartItemType = /*#__PURE__*/function (CartItemType) {
  CartItemType["DATABASE"] = "avdb";
  CartItemType["DATABASE_BUNDLE"] = "avdbBundle";
  CartItemType["ENABLEMENT"] = "enablement";
  CartItemType["GARMIN_PILOT"] = "gp";
  CartItemType["DISCOUNT_CODE"] = "promoCode";
  return CartItemType;
}(CartItemType || {});
const cartItemTypeDisplayName = {
  [CartItemType.DATABASE]: 'Database',
  [CartItemType.DATABASE_BUNDLE]: 'Database Bundle',
  [CartItemType.ENABLEMENT]: 'Enablement',
  [CartItemType.GARMIN_PILOT]: 'Garmin Pilot',
  [CartItemType.DISCOUNT_CODE]: 'Discount Code'
};
const isAvdbSubscription = thing => {
  if (thing.aircraftUuid === undefined) {
    //Aircraft Uuid may be present or null. If it is undefined, then that is illegal. `=== undefined` is necessary.
    return false;
  }
  if (thing.isRedeemed != null && typeof thing.isRedeemed !== 'boolean') {
    return false;
  }
  if (thing.redeemable != null && typeof thing.redeemable !== 'boolean') {
    return false;
  }
  if (thing.devices == null || !Array.isArray(thing.devices)) {
    return false;
  }
  if (thing.garminPilotSubscriptions != null && !Array.isArray(thing.garminPilotSubscriptions)) {
    return false;
  }
  return true;
};
const isGarminPilotSubscription = thing => {
  if (thing.customerGuid == null || typeof thing.customerGuid !== 'string') {
    return false;
  }
  if (isAvdbSubscription(thing)) {
    return false;
  }
  return true;
};
const isSubscriptionResponseError = val => {
  if (val.errorId == null || typeof val.errorId !== 'number') {
    return false;
  }
  if (val.property == null || typeof val.property !== 'string') {
    return false;
  }
  if (val.message == null || typeof val.message !== 'string') {
    return false;
  }
  return true;
};
let PendingSubscriptionJobService = /*#__PURE__*/(() => {
  class PendingSubscriptionJobService {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.httpClient = inject(HttpClient);
      this.siteUrl = this.config.site === 'FGA' ? FlyGarminLegacyBaseUrl[this.config.environment] : FlyAdminLegacyBaseUrl[this.config.environment];
      this.baseUrl = `${this.siteUrl}/api/subscription-jobs-pending/`;
    }
    searchPendingSubscriptionJobs(requestQuery) {
      let params = new HttpParams();
      for (const [key, value] of Object.entries(requestQuery)) {
        if (value != null) {
          const paramValue = typeof value === 'string' ? value : value.name;
          params = params.set(key, paramValue);
        }
      }
      return this.httpClient.get(`${this.baseUrl}`, {
        params
      });
    }
    static {
      this.ɵfac = function PendingSubscriptionJobService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PendingSubscriptionJobService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PendingSubscriptionJobService,
        factory: PendingSubscriptionJobService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PendingSubscriptionJobService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GarminPilotSubscriptionsService = /*#__PURE__*/(() => {
  class GarminPilotSubscriptionsService {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.httpClient = inject(HttpClient);
      this.siteUrl = this.config.site === 'FGA' ? FlyGarminLegacyBaseUrl[this.config.environment] : FlyAdminLegacyBaseUrl[this.config.environment];
    }
    baseUrl(version) {
      let versionPath = '';
      if (version != null && version > 1) {
        versionPath = `/v${version}`;
      }
      return `${this.siteUrl}/api${versionPath}/subscriptions/garmin-pilot`;
    }
    getPromoCode(promoCode) {
      if (promoCode.length < 1) {
        return throwError(() => new Error('Invalid promo code is provided'));
      }
      const baseUrl = this.config.site === 'FGA' ? this.baseUrl(2) : this.baseUrl();
      return this.httpClient.get(`${baseUrl}/coupons/${promoCode}`);
    }
    getPromoCodeV2(promoCode) {
      const baseUrl = this.config.site === 'FGA' ? this.baseUrl(3) : this.baseUrl(2);
      return this.httpClient.get(`${baseUrl}/coupons/${promoCode}`);
    }
    redeemPromoCode(promoCodeRedeemPayload, customerGuid) {
      let params = new HttpParams();
      if (this.config.site === 'FALA' && customerGuid != null) {
        params = params.set('customerGuid', customerGuid);
        promoCodeRedeemPayload.customerGuid = customerGuid;
      }
      const baseUrl = this.config.site === 'FGA' ? this.baseUrl(2) : this.baseUrl();
      return this.httpClient.post(`${baseUrl}/coupons/redeem`, promoCodeRedeemPayload, {
        params
      });
    }
    static {
      this.ɵfac = function GarminPilotSubscriptionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GarminPilotSubscriptionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GarminPilotSubscriptionsService,
        factory: GarminPilotSubscriptionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GarminPilotSubscriptionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API surface of `api`
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AVDB_SUBSCRIPTIONS_SERVICE_TOKEN, AbstractAvdbSubscriptionsService, AbstractPromoCodeService, AvdbDeviceIdType, AvdbPricingBundleType, CartItemType, GARMIN_PILOT_DEVICE_REGISTRATIONS_CONTROLLER_CLIENT_TOKEN, GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN, GarminPilotSubscriptionsService, MOBILE_DEVICE_SERVICE_TOKEN, PROMO_CODE_SERVICE_TOKEN, PendingSubscriptionJobService, REVOKE_SUBSCRIPTION_SERVICE_TOKEN, SKU_SERVICE_TOKEN, SUBSCRIPTIONS_CONTROLLER_CLIENT_TOKEN, SUBSCRIPTIONS_JOB_MANAGEMENT_TOKEN, SUBSCRIPTIONS_SERVICE_TOKEN, avdbPricingBundleFilterName, cartItemTypeDisplayName, isAvdbSubscription, isGarminPilotSubscription, isSubscriptionResponseError };
